import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsArrowUpRightSquare } from "react-icons/bs";

function ProjectCards({ imgPath, title, description, link, demoLink, isBlog }) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={imgPath} alt={title} />
      <Card.Body className="d-flex flex-column">
        <Card.Title className="project-card-title">{title}</Card.Title>
        <Card.Text className="project-card-text flex-grow-1">
          {description}
        </Card.Text>
        <div className="d-flex gap-2 mt-auto pt-3">
          <Button
            variant="primary"
            as="a"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
          >
            <BsArrowUpRightSquare style={{ marginBottom: "2px" }} /> &nbsp;Visit
            Site
          </Button>

          {!isBlog && demoLink && (
            <Button
              variant="outline-light"
              as="a"
              href={demoLink}
              target="_blank"
              rel="noopener noreferrer"
              size="sm"
            >
              Live Demo
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
